<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form
          ref="searchRefs"
          :model="activeSearchParams"
          size="small"
          label-width="76px"
          inline
        >
          <el-form-item
            :label="isDashboardPage ? '统计站点' : '所属站点'"
            prop="site_id"
          >
            <el-select
              v-model="activeSearchParams.site_id"
              filterable
              clearable
              placeholder="全部站点"
              style="width: 300px"
            >
              <el-option label="全部站点" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="item.id"
                :label="siteOptionLabel(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isListPage" label="客户邮箱" prop="email">
            <el-input
              v-model="activeSearchParams.email"
              placeholder="请输入客户邮箱"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="isListPage" label="关键词" prop="keyword">
            <el-input
              v-model="activeSearchParams.keyword"
              clearable
              placeholder="搜索线索内容"
              style="width: 190px"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="isListPage"
            class="cms-type-search-item"
            label="CMS类型"
            prop="cms_type"
          >
            <el-select
              v-model="activeSearchParams.cms_type"
              clearable
              placeholder="全部类型"
              style="width: 130px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="WordPress" value="wordpress"></el-option>
              <el-option label="易优CMS" value="eyoucms"></el-option>
              <el-option label="未知" value="unknown"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送状态" prop="status">
            <el-select
              v-model="activeSearchParams.status"
              clearable
              placeholder="全部状态"
              style="width: 130px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="转发成功" :value="2"></el-option>
              <el-option label="等待转发" :value="1"></el-option>
              <el-option label="转发失败" :value="0"></el-option>
              <el-option label="转发屏蔽" :value="5"></el-option>
              <el-option label="手动转发中" :value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="isDashboardPage ? '统计时间' : '创建时间'"
            prop="time_range"
          >
            <el-radio-group
              v-model="activeSearchParams.time_range"
              class="time-range-tabs"
              size="small"
            >
              <el-radio-button
                v-for="item in timeRangeOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="activeSearchParams.time_range === 'custom'"
            label="起止时间"
            prop="custom_time"
          >
            <el-date-picker
              v-model="activeSearchParams.custom_time"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 260px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div
      v-if="isDashboardPage"
      class="clue-dashboard"
      v-loading="summaryLoading"
    >
      <div class="dashboard-head">
        <div>
          <div class="dashboard-title">商机数据看板</div>
          <div class="dashboard-subtitle">
            {{ summary.scope.title || "全部站点" }}
            <template v-if="summary.scope.site && summary.scope.site.url">
              · {{ summary.scope.site.url }}
            </template>
          </div>
        </div>
        <div class="dashboard-meta">
          <span>涉及站点：{{ summary.site_count || 0 }}</span>
          <span>最近线索：{{ latestTimeText }}</span>
        </div>
      </div>

      <div class="summary-grid">
        <div
          v-for="card in summary.cards"
          :key="card.key"
          :class="['summary-card', 'summary-card--' + card.key]"
        >
          <div class="summary-card__icon">
            <i :class="summaryIcon(card.key)"></i>
          </div>
          <div class="summary-card__content">
            <span>{{ card.label }}</span>
            <strong
              >{{ formatNumber(card.value)
              }}<small>{{ card.unit }}</small></strong
            >
            <em>{{ card.extra }}</em>
          </div>
        </div>
      </div>

      <el-row :gutter="16" class="dashboard-row">
        <el-col :lg="14" :md="24" :sm="24" :xs="24">
          <el-card shadow="never" class="chart-card">
            <template #header>
              <div class="chart-title">
                <span>线索趋势</span>
                <small>当前时间范围 · 线索总数 / 已转发</small>
              </div>
            </template>
            <div ref="clueTrendChart" class="chart-canvas"></div>
          </el-card>
        </el-col>
        <el-col :lg="10" :md="24" :sm="24" :xs="24">
          <el-card shadow="never" class="chart-card">
            <template #header>
              <div class="chart-title">
                <span>线索状态分布</span>
                <small>当前筛选范围</small>
              </div>
            </template>
            <div ref="clueStatusChart" class="chart-canvas"></div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="16" class="dashboard-row">
        <el-col :lg="12" :md="24" :sm="24" :xs="24">
          <el-card shadow="never" class="chart-card">
            <template #header>
              <div class="chart-title">
                <span>{{ topChartTitle }}</span>
                <small>{{
                  summary.scope.type === "site" ? "来源页面" : "站点排行"
                }}</small>
              </div>
            </template>
            <div
              ref="clueTopChart"
              class="chart-canvas chart-canvas--small"
            ></div>
          </el-card>
        </el-col>
        <el-col :lg="12" :md="24" :sm="24" :xs="24">
          <el-card shadow="never" class="chart-card">
            <template #header>
              <div class="chart-title">
                <span>地区 / 来源补充</span>
                <small>来自线索内容字段</small>
              </div>
            </template>
            <div class="insight-list">
              <div
                v-for="item in insightRows"
                :key="item.name"
                class="insight-item"
              >
                <span>{{ item.name }}</span>
                <strong>{{ item.value }}</strong>
              </div>
              <div v-if="!insightRows.length" class="insight-empty">
                暂无可解析的地区或来源数据
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-card
      v-if="isListPage"
      class="mt-16px"
      v-loading="pager.loading"
      shadow="never"
    >
      <div></div>
      <div class="mt-16px">
        <div class="data-table-scroll" style="--table-min-width: 1480px">
          <el-table :data="pager.list">
            <el-table-column
              prop="id"
              label="线索ID"
              width="80"
            ></el-table-column>
            <el-table-column label="站点 / 网址" min-width="260">
              <template v-slot="scope">
                <div class="clue-site-cell">
                  <div class="clue-site-cell__name" :title="scope.row.name">
                    {{ scope.row.name }}
                  </div>
                  <div class="clue-site-cell__url" :title="scope.row.url">
                    {{ scope.row.url }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="客户邮箱" width="200">
              <template v-slot="scope">
                <span> {{ scope.row.email }} </span>
              </template>
            </el-table-column>
            <el-table-column label="CMS类型" width="110">
              <template v-slot="scope">
                <el-tag
                  size="small"
                  :type="cmsTypeTagType(scope.row.cms_type)"
                  :class="cmsTypeClass(scope.row.cms_type)"
                >
                  {{ cmsTypeLabel(scope.row.cms_type) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="线索内容" min-width="200">
              <template v-slot="scope">
                <div class="clue-content-cell" @click="onDetail(scope.row.id)">
                  {{ clueContentText(scope.row.content) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="160">
              <template v-slot="scope">
                <span>
                  {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="发送状态" width="100">
              <template v-slot="scope">
                <el-tag
                  size="small"
                  type="success"
                  v-if="scope.row.status === 2"
                  >转发成功</el-tag
                >
                <el-tag size="small" type="info" v-if="scope.row.status === 1"
                  >等待转发</el-tag
                >
                <el-tag size="small" type="danger" v-if="scope.row.status === 0"
                  >转发失败</el-tag
                >
                <el-tag size="small" type="danger" v-if="scope.row.status === 5"
                  >转发屏蔽</el-tag
                >
                <el-tag
                  size="small"
                  type="warning"
                  v-if="scope.row.status === 6"
                  >手动转发中</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="发送时间" width="160">
              <template v-slot="scope">
                <span v-if="scope.row.send_time">
                  {{ formatDate(scope.row.send_time, "yyyy-mm-dd hh:MM:ss") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="210">
              <template v-slot="scope">
                <div class="flex items-center">
                  <el-button type="text" @click="onDetail(scope.row.id)">
                    查看线索
                  </el-button>
                  <el-divider
                    v-if="
                      canManualForward(scope.row) &&
                      $hasPermission('clue', 'view')
                    "
                    direction="vertical"
                  ></el-divider>
                  <el-button
                    v-if="
                      canManualForward(scope.row) &&
                      $hasPermission('clue', 'view')
                    "
                    type="text"
                    :loading="manualForwardingId === scope.row.id"
                    @click="onManualForward(scope.row)"
                  >
                    {{ manualForwardButtonText(scope.row) }}
                  </el-button>
                  <el-divider
                    v-if="$hasPermission('clue', 'delete')"
                    direction="vertical"
                  ></el-divider>
                  <popup
                    v-if="$hasPermission('clue', 'delete')"
                    :content="`确定删除编号为 ${scope.row.id} 的线索？请谨慎操作。`"
                    @confirm="onDelete(scope.row)"
                  >
                    <el-button slot="trigger" type="text">删除</el-button>
                  </popup>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex justify-between mt-16px">
        <div class="flex"></div>
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>

    <edit-dialog ref="popupRefs" @refresh="getList"></edit-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import Popup from "@/components/popup";
import { Pager } from "@/utils/pager";

import {
  apiListClue,
  apiDeleteClue,
  apiClueSummary,
  apiManualForwardClue,
} from "@/api/clue";
import { apiSiteOptions } from "@/api/site";
import * as echarts from "echarts/core";
import {
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from "echarts/components";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

import EditDialog from "./dialog.vue";
import { formatDate } from "@/utils/util";

echarts.use([
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  BarChart,
  LineChart,
  PieChart,
  CanvasRenderer,
]);

const defaultSearchParams = () => ({
  site_id: "",
  email: "",
  keyword: "",
  cms_type: "",
  status: "",
  time_range: "30d",
  custom_time: [],
});

const timeRangeOptions = [
  { label: "今日", value: "today" },
  { label: "近7天", value: "7d" },
  { label: "近30天", value: "30d" },
  { label: "近半年", value: "half_year" },
  { label: "近一年", value: "1y" },
  { label: "自定义", value: "custom" },
];

export default {
  components: {
    EditDialog,
    Pagination,
    Popup,
  },
  data() {
    return {
      dashboardParams: defaultSearchParams(),
      listParams: defaultSearchParams(),
      timeRangeOptions,
      siteOptions: [],
      pager: new Pager(),
      summaryLoading: false,
      manualForwardingId: null,
      charts: {},
      summary: {
        scope: {},
        cards: [],
        status: [],
        trend: [],
        site_top: [],
        source_top: [],
        country_top: [],
        site_count: 0,
        latest_time: null,
      },
    };
  },
  computed: {
    isDashboardPage() {
      return this.$route.path === "/clue/dashboard";
    },
    isListPage() {
      return !this.isDashboardPage;
    },
    activeSearchParams() {
      return this.isDashboardPage ? this.dashboardParams : this.listParams;
    },
    latestTimeText() {
      return this.summary.latest_time
        ? this.formatDate(this.summary.latest_time, "yyyy-mm-dd hh:MM:ss")
        : "暂无";
    },
    topRows() {
      if (
        this.summary.scope.type === "site" &&
        this.summary.source_top.length
      ) {
        return this.summary.source_top.map((item) => ({
          name: item.name,
          value: item.value,
        }));
      }
      return (this.summary.site_top || []).map((item) => ({
        name: item.site_label || item.site_name || "-",
        value: item.clue_count,
      }));
    },
    topChartTitle() {
      return this.summary.scope.type === "site"
        ? "来源页面 TOP"
        : "站点线索 TOP";
    },
    insightRows() {
      const countryRows = (this.summary.country_top || []).map((item) => ({
        name: item.name,
        value: item.value,
      }));
      if (countryRows.length) {
        return countryRows;
      }
      return (this.summary.source_top || []).slice(0, 6).map((item) => ({
        name: item.name,
        value: item.value,
      }));
    },
  },
  created() {
    this.getSiteOptions();
    this.getPageData();
  },
  mounted() {
    window.addEventListener("resize", this.resizeCharts);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCharts);
    this.disposeCharts();
  },
  watch: {
    "$route.path"() {
      this.getPageData();
    },
  },
  methods: {
    formatDate,
    formatNumber(value) {
      return Number(value || 0).toLocaleString();
    },
    siteOptionLabel(site) {
      const name = site.name || "未命名站点";
      const url = site.url || "-";
      return `${name} - ${url}`;
    },
    getSiteOptions() {
      apiSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    onReset() {
      const target = this.isDashboardPage
        ? this.dashboardParams
        : this.listParams;
      Object.assign(target, defaultSearchParams());
      this.$refs.searchRefs && this.$refs.searchRefs.clearValidate();
      this.getPageData(1);
    },
    onSearch() {
      this.getPageData(1);
    },
    getPageData(page) {
      if (this.isDashboardPage) {
        this.getSummary();
        return;
      }
      this.disposeCharts();
      this.getList(page);
    },
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiListClue,
        params: this.buildRequestParams(this.listParams),
      });
    },
    getSummary() {
      this.summaryLoading = true;
      apiClueSummary(this.buildRequestParams(this.dashboardParams))
        .then((resp) => {
          this.summary = Object.assign({}, this.summary, resp || {});
          this.$nextTick(this.renderCharts);
        })
        .finally(() => {
          this.summaryLoading = false;
        });
    },
    onDetail(id) {
      this.$refs.popupRefs.openDialog(id);
    },
    onDelete(row) {
      apiDeleteClue({
        id: row.id,
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功！",
        });
        this.getList();
      });
    },
    canManualForward(row) {
      return [0, 5].includes(Number(row.status));
    },
    manualForwardButtonText(row) {
      return Number(row.status) === 0 ? "重新转发" : "手动转发";
    },
    onManualForward(row) {
      const isRetry = Number(row.status) === 0;
      this.$confirm(
        isRetry
          ? "该操作会把转发失败的线索重新加入转发队列，稍后由定时任务再次发送。"
          : "该操作将绕过过滤关键词，并发送到当前站点配置的收件邮箱。",
        `确认${isRetry ? "重新转发" : "手动转发"}线索 #${row.id}？`,
        {
          confirmButtonText: isRetry ? "确认重试" : "确认转发",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.manualForwardingId = row.id;
          return apiManualForwardClue({ id: row.id });
        })
        .then(() => {
          this.$message({
            type: "success",
            message: isRetry ? "已加入重新转发队列" : "已加入手动转发队列",
          });
          this.getList();
        })
        .catch((error) => {
          if (error !== "cancel" && error !== "close") {
            this.getList();
          }
        })
        .finally(() => {
          this.manualForwardingId = null;
        });
    },
    buildRequestParams(params) {
      const query = {
        site_id: params.site_id,
        email: params.email,
        keyword: params.keyword,
        cms_type: params.cms_type,
        status: params.status,
        time_range: params.time_range,
      };
      if (
        params.time_range === "custom" &&
        params.custom_time &&
        params.custom_time.length === 2
      ) {
        query.start_time = Math.floor(Number(params.custom_time[0]) / 1000);
        query.end_time =
          Math.floor(Number(params.custom_time[1]) / 1000) + 86399;
      }
      Object.keys(query).forEach((key) => {
        if (
          query[key] === "" ||
          query[key] === undefined ||
          query[key] === null
        ) {
          delete query[key];
        }
      });
      return query;
    },
    chart(ref) {
      if (!this.$refs[ref]) return null;
      if (!this.charts[ref]) {
        this.charts[ref] = echarts.init(this.$refs[ref]);
      }
      return this.charts[ref];
    },
    cmsTypeLabel(value) {
      const map = {
        wordpress: "WordPress",
        eyoucms: "易优CMS",
        unknown: "未知",
      };
      return map[String(value || "").toLowerCase()] || "未知";
    },
    cmsTypeTagType(value) {
      const map = {
        wordpress: "",
        eyoucms: "warning",
        unknown: "info",
      };
      return map[String(value || "").toLowerCase()] || "info";
    },
    cmsTypeClass(value) {
      return String(value || "").toLowerCase() === "wordpress"
        ? "cms-tag--wordpress"
        : "";
    },
    renderCharts() {
      this.renderTrendChart();
      this.renderStatusChart();
      this.renderTopChart();
      this.resizeCharts();
    },
    renderTrendChart() {
      const chart = this.chart("clueTrendChart");
      if (!chart) return;
      const rows = this.summary.trend || [];
      chart.setOption({
        color: ["#2f7cf6", "#18c4b8"],
        tooltip: {
          trigger: "axis",
          confine: true,
          backgroundColor: "rgba(24, 38, 61, 0.92)",
          borderWidth: 0,
          textStyle: { color: "#fff" },
        },
        legend: {
          top: 0,
          right: 0,
          itemWidth: 18,
          itemHeight: 8,
          textStyle: { color: "#607089", fontSize: 12 },
        },
        grid: { top: 42, right: 18, bottom: 28, left: 42 },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: rows.map((item) => item.label),
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "#dfe6f0" } },
          axisLabel: { color: "#607089" },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          splitLine: { lineStyle: { color: "#edf1f7" } },
          axisLabel: { color: "#607089" },
        },
        series: [
          this.lineSeries(
            "线索总数",
            rows.map((item) => item.total),
            "#2f7cf6",
            true
          ),
          this.lineSeries(
            "已转发",
            rows.map((item) => item.forwarded),
            "#18c4b8",
            false
          ),
        ],
      });
    },
    renderStatusChart() {
      const chart = this.chart("clueStatusChart");
      if (!chart) return;
      const rows = this.summary.status || [];
      const total = rows.reduce(
        (sum, item) => sum + Number(item.value || 0),
        0
      );
      chart.setOption({
        color: ["#2f7cf6", "#18c48f", "#ff4d57", "#ff9f1a"],
        tooltip: {
          trigger: "item",
          confine: true,
          backgroundColor: "rgba(24, 38, 61, 0.92)",
          borderWidth: 0,
          textStyle: { color: "#fff" },
        },
        legend: {
          orient: "vertical",
          right: 8,
          top: "middle",
          icon: "circle",
          itemWidth: 11,
          itemHeight: 11,
          textStyle: { color: "#607089", fontSize: 12 },
          formatter: (name) => {
            const target = rows.find((item) => item.name === name);
            return `${name}  ${target ? target.value : 0}`;
          },
        },
        graphic: [
          {
            type: "text",
            left: "32%",
            top: "42%",
            style: {
              text: this.formatNumber(total),
              textAlign: "center",
              fill: "#18263d",
              fontSize: 28,
              fontWeight: 700,
            },
          },
          {
            type: "text",
            left: "32%",
            top: "53%",
            style: {
              text: "总线索",
              textAlign: "center",
              fill: "#8a97aa",
              fontSize: 13,
            },
          },
        ],
        series: [
          {
            name: "线索状态",
            type: "pie",
            radius: ["52%", "74%"],
            center: ["33%", "50%"],
            minAngle: 4,
            label: { show: false },
            labelLine: { show: false },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 5,
              borderRadius: 8,
              shadowBlur: 14,
              shadowColor: "rgba(34, 50, 74, 0.12)",
            },
            data: rows,
          },
        ],
      });
    },
    renderTopChart() {
      const chart = this.chart("clueTopChart");
      if (!chart) return;
      const rows = this.topRows.slice().reverse();
      const values = rows.map((item) => Number(item.value || 0));
      const max = Math.max.apply(null, values) || 1;
      chart.setOption({
        color: ["#2f7cf6"],
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          confine: true,
          backgroundColor: "rgba(24, 38, 61, 0.92)",
          borderWidth: 0,
          textStyle: { color: "#fff" },
        },
        grid: { top: 8, right: 44, bottom: 18, left: 110 },
        xAxis: {
          type: "value",
          minInterval: 1,
          splitLine: { lineStyle: { color: "#edf1f7" } },
          axisLabel: { color: "#607089" },
        },
        yAxis: {
          type: "category",
          data: rows.map((item) => this.shortText(item.name, 12)),
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "#dfe6f0" } },
          axisLabel: { color: "#607089" },
        },
        series: [
          {
            type: "bar",
            barWidth: 14,
            barGap: "-100%",
            data: rows.map(() => max),
            silent: true,
            itemStyle: { color: "#edf3fb", borderRadius: [0, 8, 8, 0] },
          },
          {
            name: "线索数",
            type: "bar",
            barWidth: 14,
            data: values,
            label: {
              show: true,
              position: "right",
              color: "#31415a",
              fontWeight: 600,
            },
            itemStyle: {
              borderRadius: [0, 8, 8, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#12c2e9" },
                { offset: 1, color: "#2f7cf6" },
              ]),
            },
          },
        ],
      });
    },
    lineSeries(name, data, color, area) {
      return {
        name,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        data: data.map((item) => Number(item || 0)),
        areaStyle: area
          ? {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: this.hexToRgba(color, 0.24) },
                { offset: 1, color: this.hexToRgba(color, 0.02) },
              ]),
            }
          : undefined,
        itemStyle: { color, borderColor: "#fff", borderWidth: 2 },
        lineStyle: {
          width: 3,
          color,
          shadowBlur: 8,
          shadowColor: this.hexToRgba(color, 0.28),
        },
      };
    },
    resizeCharts() {
      Object.keys(this.charts).forEach((key) => {
        this.charts[key].resize();
      });
    },
    disposeCharts() {
      Object.keys(this.charts).forEach((key) => {
        this.charts[key].dispose();
      });
      this.charts = {};
    },
    summaryIcon(key) {
      const icons = {
        total: "el-icon-data-analysis",
        site_count: "el-icon-monitor",
        forwarded: "el-icon-check",
        waiting: "el-icon-time",
        failed: "el-icon-warning-outline",
        blocked: "el-icon-circle-close",
      };
      return icons[key] || "el-icon-data-line";
    },
    shortText(text, length) {
      text = String(text || "-");
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    clueContentText(content) {
      if (!content) return "-";
      try {
        const decoded =
          typeof content === "string" ? JSON.parse(content) : content;
        if (decoded && typeof decoded === "object") {
          const parts = Object.keys(decoded)
            .filter(
              (key) =>
                !this.isHiddenContentKey(key) &&
                !this.isSourceContentKey(key) &&
                this.normalizeFieldKey(key) !== "customfields" &&
                this.isMeaningfulContentValue(decoded[key])
            )
            .map((key) => {
              const value = decoded[key];
              return `${this.fieldLabel(key)}: ${this.formatContentValue(
                value,
                key
              )}`;
            });
          const customKey = Object.keys(decoded).find(
            (key) => this.normalizeFieldKey(key) === "customfields"
          );
          if (customKey && Array.isArray(decoded[customKey])) {
            decoded[customKey].forEach((item) => {
              if (
                !item ||
                typeof item !== "object" ||
                this.normalizeFieldKey(item.type) === "quiz" ||
                !this.isMeaningfulContentValue(item.value)
              ) {
                return;
              }
              const field = String(item.field || "").trim();
              const label = String(item.label || field).trim();
              parts.push(
                `${this.fieldLabel(
                  label || field || "扩展字段"
                )}: ${this.formatContentValue(item.value, field)}`
              );
            });
          }
          return parts.length ? parts.join("；") : "-";
        }
      } catch (error) {
        return String(content);
      }
      return String(content);
    },
    isHiddenContentKey(key) {
      const normalized = this.normalizeFieldKey(key);
      return [
        "raw",
        "mathquiz",
        "protocol",
        "protocolversion",
        "origincms",
        "originplugin",
        "originpluginversion",
        "customfields",
      ].includes(normalized);
    },
    isSourceContentKey(key) {
      return /^origin/i.test(this.normalizeFieldKey(key));
    },
    isMeaningfulContentValue(value) {
      if (value === null || value === undefined) return false;
      if (Array.isArray(value)) {
        return value.some((item) => this.isMeaningfulContentValue(item));
      }
      if (value && typeof value === "object") {
        return Object.keys(value).some((key) =>
          this.isMeaningfulContentValue(value[key])
        );
      }
      return String(value).trim() !== "";
    },
    normalizeFieldKey(key) {
      return String(key || "")
        .toLowerCase()
        .replace(/[\s_\-\t]+/g, "");
    },
    fieldLabel(key) {
      const normalized = this.normalizeFieldKey(key);
      const labels = {
        yourname: "姓名",
        name: "姓名",
        姓名: "姓名",
        称呼: "姓名",
        contactname: "姓名",
        联系人: "姓名",
        youremail: "邮箱",
        mail: "邮箱",
        email: "邮箱",
        邮箱: "邮箱",
        电子邮箱: "邮箱",
        yourphone: "手机号",
        phone: "手机号",
        tel: "手机号",
        mobile: "手机号",
        手机: "手机号",
        手机号: "手机号",
        电话: "手机号",
        yourcountry: "国家",
        country: "国家",
        国家: "国家",
        company: "公司名称",
        公司: "公司名称",
        公司名称: "公司名称",
        yourmessage: "留言内容",
        message: "留言内容",
        content: "留言内容",
        内容: "留言内容",
        留言: "留言内容",
        留言内容: "留言内容",
        yourfile: "附件",
        attachments: "附件",
        attachment: "附件",
        file: "附件",
        files: "附件",
        附件: "附件",
        originip: "IP地址",
        originurl: "来源页面",
        origincountry: "国家",
        originregion: "省/州",
        origincity: "城市",
        originform: "表单名称",
      };
      return labels[normalized] || key;
    },
    formatContentValue(value, key = "") {
      if (value === "" || value === null || value === undefined) {
        return "-";
      }
      if (Array.isArray(value)) {
        if (!value.length) return "-";
        const normalized = this.normalizeFieldKey(key);
        if (normalized.includes("attachment") || normalized.includes("file")) {
          return "附件";
        }
        const flat = [];
        value.forEach((item) => {
          if (Array.isArray(item)) {
            flat.push(this.formatContentValue(item, key));
          } else if (item !== null && typeof item !== "object") {
            flat.push(String(item));
          }
        });
        return flat.filter(Boolean).join("，") || "-";
      }
      if (typeof value === "object") {
        return JSON.stringify(value);
      }
      return String(value);
    },
    hexToRgba(hex, opacity) {
      const value = String(hex || "#2f7cf6").replace("#", "");
      const r = parseInt(value.slice(0, 2), 16);
      const g = parseInt(value.slice(2, 4), 16);
      const b = parseInt(value.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.cms-type-search-item {
  ::v-deep .el-form-item__label {
    white-space: nowrap;
  }
}

.time-range-tabs {
  display: inline-flex;
  vertical-align: middle;

  ::v-deep .el-radio-button__inner {
    min-width: 72px;
    color: #5d6c82;
    border-color: #dfe6f0;
    background: #f8fbff;
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    border-color: #2f7cf6;
    background: linear-gradient(135deg, #2f7cf6, #12c2e9);
    box-shadow: -1px 0 0 0 #2f7cf6;
  }
}

.clue-content-cell {
  display: block;
  max-width: 100%;
  padding: 8px 10px;
  color: #4b5563;
  border: 1px solid transparent;
  border-radius: 8px;
  line-height: 20px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.16s ease, background-color 0.16s ease,
    border-color 0.16s ease;

  &:hover {
    color: #1b6cff;
    background: #eef5ff;
    border-color: #cfe0ff;
  }
}

.clue-site-cell {
  min-width: 0;
  line-height: 1.45;
}

.clue-site-cell__name,
.clue-site-cell__url {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clue-site-cell__name {
  color: #303133;
  font-weight: 500;
}

.clue-site-cell__url {
  margin-top: 2px;
  color: #909399;
  font-size: 12px;
}

.cms-tag--wordpress {
  color: #21759b;
  background-color: #e9f4f8;
  border-color: #b9d8e5;
}

.clue-dashboard {
  margin-top: 16px;
  padding: 16px;
  background: radial-gradient(
      circle at 15% 0%,
      rgba(47, 124, 246, 0.08),
      transparent 30%
    ),
    radial-gradient(circle at 90% 5%, rgba(24, 196, 184, 0.08), transparent 28%),
    #f4f7fb;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
}

.dashboard-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 14px;
}

.dashboard-title {
  color: #18263d;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
}

.dashboard-subtitle,
.dashboard-meta {
  color: #8a97aa;
  font-size: 13px;
  line-height: 22px;
}

.dashboard-meta {
  display: flex;
  gap: 16px;
  white-space: nowrap;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
}

.summary-card {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 13px;
  min-height: 112px;
  padding: 16px;
  background: #fff;
  border: 1px solid rgba(223, 230, 240, 0.92);
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(34, 50, 74, 0.06);

  &::after {
    content: "";
    position: absolute;
    right: -36px;
    top: -36px;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(47, 124, 246, 0.1);
  }
}

.summary-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 auto;
  color: #fff;
  border-radius: 8px;
  background: linear-gradient(135deg, #2f7cf6, #12c2e9);
  box-shadow: 0 10px 18px rgba(47, 124, 246, 0.28);

  i {
    font-size: 22px;
  }
}

.summary-card__content {
  position: relative;
  z-index: 1;
  min-width: 0;

  span {
    display: block;
    color: #5d6c82;
    font-size: 13px;
    font-weight: 600;
  }

  strong {
    display: block;
    margin-top: 7px;
    color: #18263d;
    font-size: 28px;
    line-height: 34px;
    white-space: nowrap;

    small {
      margin-left: 4px;
      color: #8a97aa;
      font-size: 12px;
      font-weight: 400;
    }
  }

  em {
    display: block;
    margin-top: 4px;
    color: #8a97aa;
    font-size: 12px;
    font-style: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.summary-card--site_count .summary-card__icon {
  background: linear-gradient(135deg, #13c2c2, #1cd4a7);
  box-shadow: 0 10px 18px rgba(19, 194, 194, 0.28);
}

.summary-card--waiting .summary-card__icon {
  background: linear-gradient(135deg, #7c5cff, #a874ff);
  box-shadow: 0 10px 18px rgba(124, 92, 255, 0.28);
}

.summary-card--forwarded .summary-card__icon {
  background: linear-gradient(135deg, #18c48f, #5ddebd);
  box-shadow: 0 10px 18px rgba(24, 196, 143, 0.28);
}

.summary-card--failed .summary-card__icon {
  background: linear-gradient(135deg, #ff4d57, #ff8a65);
  box-shadow: 0 10px 18px rgba(255, 77, 87, 0.26);
}

.summary-card--blocked .summary-card__icon {
  background: linear-gradient(135deg, #ff9f1a, #ffc247);
  box-shadow: 0 10px 18px rgba(255, 159, 26, 0.3);
}

.dashboard-row {
  margin-top: 16px;
}

.chart-card {
  border-radius: 8px;
  border-color: #e6ebf2;
  box-shadow: 0 10px 24px rgba(34, 50, 74, 0.05);

  ::v-deep .el-card__header {
    background: linear-gradient(180deg, #fff, #fbfdff);
  }
}

.chart-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  color: #22324a;
  font-size: 15px;
  font-weight: 700;

  small {
    color: #8a97aa;
    font-size: 12px;
    font-weight: 400;
  }
}

.chart-canvas {
  width: 100%;
  height: 300px;
}

.chart-canvas--small {
  height: 260px;
}

.insight-list {
  min-height: 260px;
}

.insight-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  background: #f8fbff;
  border: 1px solid #edf1f7;
  border-radius: 8px;

  span {
    min-width: 0;
    color: #5d6c82;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong {
    color: #18263d;
    font-size: 16px;
  }
}

.insight-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  color: #9aa8ba;
  font-size: 13px;
}

@media (max-width: 1400px) {
  .summary-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .dashboard-head,
  .dashboard-meta {
    display: block;
  }

  .summary-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
